module.exports = new __parcel__URL__("atlassian-home.dd2e289b.svg").toString();